export const formatPhone = (phone) => {
  if (!phone) return "-";

  let formattedPhone = phone;

  if (phone.includes("+55")) {
    formattedPhone = phone.replace("+55", "");

    // Se não tiver 11 dígitos e começar com DDD, adiciona o 9 depois do DDD
    if (formattedPhone.length === 10) {
      formattedPhone =
        formattedPhone.slice(0, 2) + "9" + formattedPhone.slice(2);
    }

    return `(${formattedPhone.slice(0, 2)}) ${formattedPhone.slice(
      2,
      7
    )}-${formattedPhone.slice(7)}`;
  }

  return phone;
};

// Formatar CPF
export const formatCPF = (cpf) => {
  if (!cpf || cpf.length !== 11) return cpf;
  return `${cpf.slice(0, 3)}.${cpf.slice(3, 6)}.${cpf.slice(6, 9)}-${cpf.slice(
    9
  )}`;
};

// Formatar CNPJ
export const formatCNPJ = (cnpj) => {
  if (!cnpj || cnpj.length !== 14) return cnpj;
  return `${cnpj.slice(0, 2)}.${cnpj.slice(2, 5)}.${cnpj.slice(
    5,
    8
  )}/${cnpj.slice(8, 12)}-${cnpj.slice(12)}`;
};

// Limpar telefone (remover formatação)
export const cleanPhone = (phone) => {
  if (!phone) return "";

  // Remove todos os caracteres não numéricos
  let cleaned = phone.replace(/\D/g, "");

  // Se começar com 55 e tiver mais de 11 dígitos, adiciona o +
  if (cleaned.length > 11 && cleaned.startsWith("55")) {
    cleaned = "+" + cleaned;
  } else if (cleaned.length === 11 || cleaned.length === 10) {
    // Se for número nacional, adiciona +55
    cleaned = "+55" + cleaned;
  }

  return cleaned;
};

// Validar CPF
export const validateCPF = (cpf) => {
  if (!cpf) return false;

  cpf = cpf.replace(/\D/g, "");

  if (cpf.length !== 11) return false;

  // Verifica se todos os dígitos são iguais
  if (/^(\d)\1{10}$/.test(cpf)) return false;

  // Validação do primeiro dígito verificador
  let sum = 0;
  for (let i = 0; i < 9; i++) {
    sum += parseInt(cpf.charAt(i)) * (10 - i);
  }
  let checkDigit1 = 11 - (sum % 11);
  if (checkDigit1 === 10 || checkDigit1 === 11) checkDigit1 = 0;
  if (parseInt(cpf.charAt(9)) !== checkDigit1) return false;

  // Validação do segundo dígito verificador
  sum = 0;
  for (let i = 0; i < 10; i++) {
    sum += parseInt(cpf.charAt(i)) * (11 - i);
  }
  let checkDigit2 = 11 - (sum % 11);
  if (checkDigit2 === 10 || checkDigit2 === 11) checkDigit2 = 0;
  if (parseInt(cpf.charAt(10)) !== checkDigit2) return false;

  return true;
};

// Validar CNPJ
export const validateCNPJ = (cnpj) => {
  if (!cnpj) return false;

  cnpj = cnpj.replace(/\D/g, "");

  if (cnpj.length !== 14) return false;

  // Verifica se todos os dígitos são iguais
  if (/^(\d)\1{13}$/.test(cnpj)) return false;

  // Validação do primeiro dígito verificador
  let sum = 0;
  let weight = 5;
  for (let i = 0; i < 12; i++) {
    sum += parseInt(cnpj.charAt(i)) * weight;
    weight = weight === 2 ? 9 : weight - 1;
  }
  let checkDigit1 = sum % 11;
  checkDigit1 = checkDigit1 < 2 ? 0 : 11 - checkDigit1;
  if (parseInt(cnpj.charAt(12)) !== checkDigit1) return false;

  // Validação do segundo dígito verificador
  sum = 0;
  weight = 6;
  for (let i = 0; i < 13; i++) {
    sum += parseInt(cnpj.charAt(i)) * weight;
    weight = weight === 2 ? 9 : weight - 1;
  }
  let checkDigit2 = sum % 11;
  checkDigit2 = checkDigit2 < 2 ? 0 : 11 - checkDigit2;
  if (parseInt(cnpj.charAt(13)) !== checkDigit2) return false;

  return true;
};

// Preparar dados do cliente para envio
export const prepareCustomerData = (formData) => {
  if(formData?.tags){
    delete formData?.tags;
  }
  
  const data = { ...formData };

  // Limpar telefones
  if (data.phone_primary) {
    data.phone_primary = cleanPhone(data.phone_primary);
  }
  if (data.phone_secondary) {
    data.phone_secondary = cleanPhone(data.phone_secondary);
  }
  if (data.emergency_contact_phone) {
    data.emergency_contact_phone = cleanPhone(data.emergency_contact_phone);
  }

  // Limpar documentos
  if (data.cpf) {
    data.cpf = data.cpf.replace(/\D/g, "");
  }
  if (data.cnpj) {
    data.cnpj = data.cnpj.replace(/\D/g, "");
  }
  if (data.zip_code) {
    data.zip_code = data.zip_code.replace(/\D/g, "");
  }

  // Converter strings vazias para null
  Object.keys(data).forEach((key) => {
    if (data[key] === "") {
      data[key] = null;
    }
  });

  return data;
};

// Buscar CEP
export const searchCEP = async (cep) => {
  try {
    const cleanCEP = cep.replace(/\D/g, "");
    if (cleanCEP.length !== 8) {
      throw new Error("CEP deve ter 8 dígitos");
    }

    const response = await fetch(`https://viacep.com.br/ws/${cleanCEP}/json/`);
    const data = await response.json();

    if (data.erro) {
      throw new Error("CEP não encontrado");
    }

    return {
      success: true,
      data: {
        address: data.logradouro,
        neighborhood: data.bairro,
        city: data.localidade,
        state: data.uf,
      },
    };
  } catch (error) {
    return {
      success: false,
      error: error.message,
    };
  }
};
